/** Labels en español para campos del formulario principal de Derechos de Agua */
const WATER_RIGHT_FIELD_LABELS = {
	// Tab Datos Generales
	establishment_id: 'Unidad de Cultivo',
	region_id: 'Región',
	commune_id: 'Comuna',
	province_id: 'Provincia',
	company_id: 'Empresa',
	resolution_number: 'N° Resolución DAA',
	resolution_date: 'Fecha de Resolución',
	file_number: 'N° Expediente',
	water_rights_status_id: 'Estado del Derecho',
	water_right_type_id: 'Tipo de Derecho',
	water_source_type_id: 'Tipo de Fuente',
	water_use_type_id: 'Tipo de Uso',
	water_use_status_id: 'Estado de Uso',
	installation_location_ids: 'Ubicación de Instalación',
	water_source_id: 'Fuente de Agua',
	water_source_ids: 'Fuentes de Agua',
	// Tab Información del Caudal
	has_annual_average_flow: 'Caudal Promedio Anual',
	has_annual_flow_rate: 'Caudal Promedio Anual',
	annual_average_flow: 'Caudal Anual Promedio',
	annual_average_flow_rate: 'Caudal Anual Promedio',
	flow_rate_unit_id: 'Unidad de Caudal',
	has_ecological_flow: 'Caudal Ecológico Promedio',
	has_ecological_flow_rate: 'Caudal Ecológico Promedio',
	ecological_flow: 'Caudal Ecológico (l/s)',
	ecological_flow_rate: 'Caudal Ecológico (l/s)',
	// Tab Registro y Tramitación
	works_registration_date: 'Fecha Registro de Obras',
	report_transmission_start: 'Inicio de Tramitación y Reporte',
	resolution_name: 'Nombre de Resolución',
	resolution_region_id: 'Región (Registro y Tramitación)',
	// Tab C.B.R
	real_estate_registry_id: 'C.B.R',
	fojas: 'Fojas',
	cbr_number: 'N° C.B.R',
	cbr_year: 'Año C.B.R',
	// Tab CPA DGA
	certificate_number: 'N° Certificado',
	certificate_year: 'Año Certificado',
	// Grillas (children)
	water_right_id: 'Derecho de Agua',
	right_exercise_type_id: 'Ejercicio del Derecho',
	january: 'Enero',
	february: 'Febrero',
	march: 'Marzo',
	april: 'Abril',
	may: 'Mayo',
	june: 'Junio',
	july: 'Julio',
	august: 'Agosto',
	september: 'Septiembre',
	october: 'Octubre',
	november: 'Noviembre',
	december: 'Diciembre',
	name: 'Nombre',
	utm_north_intake: 'UTM Norte Captación',
	utm_east_intake: 'UTM Este Captación',
	utm_north_restitution: 'UTM Norte Restitución',
	utm_east_restitution: 'UTM Este Restitución',
	utm_zone_id: 'Huso UTM',
	geodetic_datum_id: 'Datum Geodésico',
	latitude_intake: 'Latitud Captación',
	longitude_intake: 'Longitud Captación',
	latitude_restitution: 'Latitud Restitución',
	longitude_restitution: 'Longitud Restitución',
	intake_coordinates_id: 'Coordenada de Captación',
	restitution_coordinates_id: 'Coordenada de Restitución',
	distance: 'Distancia',
	distance_unit: 'Unidad de Distancia',
	elevation_difference: 'Desnivel',
};

/** Backend field name → Formik field name (cuando difieren) */
const FORM_FIELD_FROM_BACKEND = {
	ecological_flow_rate: 'ecological_flow',
	annual_average_flow_rate: 'annual_average_flow',
	has_ecological_flow_rate: 'has_ecological_flow',
	has_annual_flow_rate: 'has_annual_average_flow',
	water_source_ids: 'water_source_id',
};

const ENGLISH_PATTERNS = [
	{ re: /cannot be null/i, es: 'tiene un valor inválido' },
	{ re: /is required|must be provided|field required/i, es: 'es requerido' },
	{ re: /must be a `?string`? type/i, es: 'debe ser texto' },
	{ re: /must be a `?number`? type/i, es: 'debe ser un número' },
	{ re: /must be a valid date/i, es: 'debe ser una fecha válida' },
	{ re: /must be greater than or equal to/i, es: 'debe ser mayor o igual al mínimo permitido' },
	{ re: /must be less than or equal to/i, es: 'debe ser menor o igual al máximo permitido' },
	{ re: /invalid ObjectId|not a valid ObjectId/i, es: 'tiene un identificador inválido' },
	{ re: /already exists|duplicate/i, es: 'ya existe un registro con estos datos' },
	{ re: /Internal Server Error/i, es: 'Error interno del servidor' },
	{ re: /Invalid credentials/i, es: 'Credenciales inválidas' },
];

const extractFieldFromText = (text) => {
	const leading = text.match(/^([a-z][a-z0-9_]*)\s/i);
	if (leading?.[1]) return leading[1];
	const quoted = text.match(/'([a-z][a-z0-9_]*)'/i);
	if (quoted?.[1]) return quoted[1];
	const yupType = text.match(/([a-z][a-z0-9_]*) must be a/i);
	if (yupType?.[1]) return yupType[1];
	const inBody = text.match(/\b([a-z][a-z0-9_]*_id)\b/);
	return inBody?.[1] || null;
};

const labelFor = (field) =>
	field ? (WATER_RIGHT_FIELD_LABELS[field] || field.replace(/_id$/, '').replace(/_/g, ' ')) : null;

/** Normaliza distintas formas de error API / Redux unwrap → { message } */
export function normalizeApiError(error) {
	if (error == null) return { message: 'Error al guardar. Por favor, intente nuevamente.' };
	if (typeof error === 'string') return { message: error };
	if (error instanceof Error) {
		return { message: error.message || 'Error al guardar. Por favor, intente nuevamente.' };
	}
	if (Array.isArray(error)) {
		const parts = error.map(item =>
			typeof item === 'string' ? item : (item?.msg || item?.message || JSON.stringify(item))
		);
		return { message: parts.join('; ') };
	}
	if (typeof error === 'object') {
		const detail = error.detail ?? error.message ?? error.error;
		if (Array.isArray(detail)) {
			const parts = detail.map(d => {
				if (typeof d === 'string') return d;
				const field = d?.loc?.slice(-1)?.[0];
				const label = field ? labelFor(String(field)) : null;
				if (label && /float_parsing|int_parsing|string_type|value_error/i.test(d?.type || d?.msg || '')) {
					return `${label}: valor inválido`;
				}
				return d?.msg || JSON.stringify(d);
			});
			return { message: parts.join('; ') };
		}
		if (detail && typeof detail === 'object') {
			return { message: JSON.stringify(detail) };
		}
		if (typeof detail === 'string') return { message: detail };
	}
	return { message: String(error) };
};

const translateEnglishSnippet = (text, label) => {
	for (const { re, es } of ENGLISH_PATTERNS) {
		if (re.test(text)) {
			return label ? `${label} ${es}` : text.replace(re, es);
		}
	}
	return null;
};

/** @returns {{ message: string, field?: string, formField?: string }} */
export function mapBackendFieldError(error) {
	const { message: raw } = normalizeApiError(error);
	const text = String(raw || 'Error al guardar el derecho de agua. Por favor, intente nuevamente.');

	const field = extractFieldFromText(text);
	const label = labelFor(field);

	if (label) {
		const translated = translateEnglishSnippet(text, label);
		if (translated) {
			return {
				message: translated.startsWith(label) ? translated : `El campo ${label} ${translated.replace(label, '').trim() || 'tiene un valor inválido'}`,
				field,
				formField: FORM_FIELD_FROM_BACKEND[field] || field,
			};
		}
		// Mensaje genérico con label si reconocemos el campo
		const cleaned = text.replace(new RegExp(field, 'g'), label);
		return {
			message: cleaned === text ? `${label}: ${text}` : cleaned,
			field,
			formField: FORM_FIELD_FROM_BACKEND[field] || field,
		};
	}

	const generic = translateEnglishSnippet(text, null);
	return { message: generic || text };
}

if (typeof process !== 'undefined' && process.env?.NODE_ENV !== 'production') {
	const cases = [
		'resolution_region_id cannot be null',
		'real_estate_registry_id cannot be null',
		'establishment_id is required',
	];
	for (const msg of cases) {
		const r = mapBackendFieldError({ message: msg });
		console.assert(!r.message.includes('_id'), `[mapBackendFieldError] ${msg} → ${r.message}`);
	}
}
